import React, { useState, useEffect, useRef, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setGeoLoactionStateAction,
  setRegionActions,
  SetClientActions,
  setZoneActions,
  setClientBranchCreateActions,
  setClientBranchesRetrieveActions,
  SetBranchEditActions,
  setEmployeetListsActions,
  SetEmployeeDeleteActions,
  getClientBranchIds,
  getEMployeeInquriyIDS,
  getClientEditActions,
  getSideBarfilesActions,
  SetVerifiedUserActions,
  SettheExcelSheeetUpaloads,
  SetEmployeeProfileDetailsID,
  SetStatusBTN,
  SetISPendingDetails,
  getLeaveStatusPersonsListed,
  getShiftStatusPersonsListed,
  setTheShiftExcelSheetIDS,
  SettheActiveTabsActionClientDetails, ///---To---Make---Active--------------------------------
  Branch_EDIT_CLIENT_DETAILS,
  setEditableActions, ///readable
  StetheAttendanceExportActions,
  setTheUserObjects, /////--user---objects
  SetTheSuperviorsListACtions, ///superviors
  setTheSuperviorsgeteListActions, ///--add or remove
  setCreateActive,
  setThePageIndex,
  setTablePositionPersist,
} from "../../../Redux/Slice";
import Select from "react-select";
import "../../../StyleSheet/MainComponent/ClientBranches/ClientBrachCreate.scss";
import ClientBranchCreate from "./ClientBranchCreate";
import correctIcons from "../../../Assets/AppComponent/icons/Group 359.svg";
import Pending from "../../../Assets/AppComponent/icons/Group 145.svg";
import houseKeeping from "../../../Assets/AppComponent/icons/Role/Union.png";
import Regionicons from "../../../Assets/AppComponent/icons/Locationicons/Layer_1 .png";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import empployeeIcons from "../../../Assets/AppComponent/icons/Employee/Group 349.png";
import { useNavigate } from "react-router-dom";
import MotionPhotosAutoIcon from "@mui/icons-material/MotionPhotosAuto";
import Pendingimg from "../../../Assets/AppComponent/icons/Group 145.svg";
import { DateRangePicker, Header } from "rsuite";
import subDays from "date-fns/subDays";
import startOfWeek from "date-fns/startOfWeek";
import endOfWeek from "date-fns/endOfWeek";
import addDays from "date-fns/addDays";
import "rsuite/dist/rsuite.css";
import isAfter from "date-fns/isAfter";
import SiteCreateEdit from "../SiteTransfer/SiteCreateEdit";
import AddModeratorIcon from "@mui/icons-material/AddModerator";
import DeleteImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-05.svg";
import EditImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-04 (1).svg";
import Xmark from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-06.svg";

///---excel sheet download
import * as XLSX from "xlsx";
import Spreadsheet from "react-spreadsheet";
import { saveAs } from "file-saver";

////---------------Shift-------------------------------
import {
  SetShiftSearchActions,
  setShiftDeletCall,
  setShiftListsActions,
  setClientBranchActions,
} from "../../../Redux/Slice";
import ReactTable from "../../AppComponent/Table";
import Delete from "../../AppComponent/Popup/Delete";
import ShiftCreateForm from "../../../Component/MainComponent/Shift/ShiftCreateForm";
import "../../../StyleSheet/MainComponent/Shift/Shifts.scss";
import "../../../StyleSheet/MainComponent/Client/ClientDetails.scss";
import profile2 from "../../../Assets/AppComponent/Profile/profile2.png";
import { el, tr } from "date-fns/locale";
import { NavLink } from "react-router-dom";
import ExcelSheetUpload from "../../AppComponent/Popup/ExcelSheetUpload";
import Permission from "./Permission";
import ShiftExcelSheetG from "./ShiftExcelSheetG";
import BlackListCeatePoup from "../Blacklist/BlackListCreatePop";
import swal from "sweetalert2";
import Swal from "sweetalert2";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import ExcelFormatDwonload from "./ExcelFormatDwonload";
import ActiveEmployeeCreate from "../Active/ActiveEmployeeCreate";
import Superviors from "./Superviors";
import GridOnIcon from "@material-ui/icons/GridOn";
import ApproveEmployee from "./ApproveEmployee";
import _ from "lodash";
import ExcelSheetImage from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-22.svg"
import BackImage from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-20.svg";
import downloadoffer from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-07.svg";

const ClientDetails = () => {
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
   const TablePositionPersist = useSelector(
    (state) => state.PreviousPagePosition.TablePositionPersist
  );

  const Swal = require("sweetalert2");

  const navigate = useNavigate();
  const [ExcelSheetaLLPopup, setExcelSheetPopup] = useState(false);

  ////--------Shift-------------Excel----_Create---------------
  const [ExcelSheetpop, setExcelSheetPo] = useState(false);
  ///-------------------------Shift----Functionality
  const [dtpagesize, setdtPagesize] = useState(10);
  const [dataShift, setDatas] = useState([]);
  const [pageSize, setPageSize] = useState(20);
 const [search,setsearch] = useState(
      TablePositionPersist?.Shift_empDatas?.search == undefined ||
      TablePositionPersist?.Shift_empDatas?.search == ""
        ? ''
        : TablePositionPersist?.Shift_empDatas?.search
    );  
  

    const [currentPageShift, setCurrentPage] = useState(
        TablePositionPersist?.Shift_empDatas?.page == undefined
          ? 1
          : TablePositionPersist.Shift_empDatas.page
      );


  const [newpages, setNewpage] = useState(1);
  const [dtpageindex, setdtPageindex] = useState(1);
  const [DeleteID, setDeleteID] = useState("");
  const [DeletePOPUP, setDeletePOPUP] = useState(false);
  const [EditPopup, setEditpopup] = useState(false);
  const [EditIDSHIFT, setEditID] = useState("");
  const [ShiftSear, setSearch] = useState("");
  const [ShiftCreatePOPup, setShiftCreatePopup] = useState(false);
  const state = useSelector((state) => state);
  const dispatch = useDispatch();
  const [shift, setShitfs] = useState([]);
  const [Counts, setCount] = useState(1);
  const ref = useRef({});
  ///----Shift-------Upload----get------------------
  const [dtpageindexShift, setdtPageindexshift] = useState(1);
  const [dtpagesizeshift, setdtPagesizeshift] = useState(10);
  const [pageSizeshift, setPageSizeshift] = useState(10);
  const [newpagesshift, setNewpageshift] = useState(1);
  const [currentPageshift, setCurrentPageshift] = useState(1);
  const [ActiveFor, setActiveFor] = useState(1); ///by based the it will move to the release or the mada as black list
  // ----------------__Site----transfer------------------
  const [EmployeeIDs, setEmployeeIDs] = useState();
  const [createpoup, setcreatepoup] = useState(false);

  ////--Black---list---------------------------------------
  const [EmployeePop, setEmployeePopblack] = useState(false);
  const [EmployeeIDsblacklist, setEmployeeIDsblack] = useState();
  const [createblack, setcreatepoupblack] = useState(false);

  const capitalizeFirstLetter = (Letter) => {
    return Letter.charAt(0).toUpperCase() + Letter.slice(1);
  };
  //-----Supervisor---
  const [sno, setsno] = useState(0);

  const [SuperviorsState, setSuperviorsState] = useState(false);
  ///---InActive----Create---
  const [InActiveCreatePop, setInActiveCreatePoup] = useState(false);
  const [InActiveCreateId, setInactiveCrateId] = useState("");

  ///----Employee states

  const [Employeesdata, setEmployeeDatas] = useState([]);
  const [DeletePopup, setDeletepopup] = useState(false);
  const [DeleteId, setDeleteEmployeeID] = useState();
  const [EditPopupCall, setEditPopup] = useState(false);

  const [dtpageindexemp, setdtPageindexemp] = useState(1);
  const [dtpagesizeemp, setdtPagesizeemp] = useState(10);

  const [pageSizeemp, setPageSizeemp] = useState(10);
  const [newpagesemp, setNewpageemp] = useState(1);
  const [searchemp, setsearchEmp] = useState("");
  const [Emptotalcoun, setTotallCount] = useState();
  const [EmpDAta, setEmpdatas] = useState([]);
  const [currentPageemp, setCurrentPageemp] = useState(1);

  ///---remove supervisor
  const [checked, setchecked] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [ListedIds, setlistedids] = useState([]);

  const handleHeaderCheckboxChange = (e) => {
    // console.log(ListedIds, "ListedIds", e);

    if (e) {
      setchecked(true);
      setSelectedIds(ListedIds);
    } else {
      setSelectedIds([]);
      setchecked(false);
    }
  };

  // Function to handle checkbox change
  const handleCheckboxChange = (id) => {
    // Check if the id is already in the selectedIds array
    const isSelected = selectedIds.includes(id);

    if (isSelected) {
      // If id is already selected, remove it from the array
      const updatedIds = selectedIds.filter((selectedId) => selectedId !== id);
      setSelectedIds(updatedIds);
    } else {
      // If id is not selected, add it to the array
      setSelectedIds([...selectedIds, id]);
    }

    // You can perform other actions based on the checkbox state change here
    // For example, update server data or local state
  };

  //--EXCELSHEET----UPLOAD----------------

  const [ExcelSheeTFORKYCPopup, setExcelSheetFORKYCPopup] = useState(false);
  const [getidforupload, setidforuploaddata] = useState({
    client_id: "",
    user_id: "",
  });
  const [OldEmp, setOldEMp] = useState({
    label: "CURRENT EMPLOYEE",
    value: false,
  });

  const oldemloyeeOptions = [
    {
      value: true,
      label: "OLD EMPLOYEE",
    },
    {
      value: false,
      label: "CURRENT EMPLOYEE",
    },
  ];
  const [oldemplo, setoldemp] = useState({ old_employee: false });

  //----shift---upload----download---
  const [ShiftUpload, setShiftUpload] = useState([
    [
      { value: "SL.NO" },
      { value: "NAME" },
      { value: "PHONE NUMBER" },
      { value: "1 Tue" },
      { value: "2 Wed" },
      { value: "Thu" },
      { value: "Fri" },
      { value: "Sat" },
      { value: "Sun" },
      { value: "Mon" },
      { value: "Tue" },
      { value: "Wed" },
      { value: "Thu" },
      { value: "Fri" },
      { value: "Sat" },
      { value: "Sun" },
      { value: "Mon" },
      { value: "Tue" },
      { value: "Wed" },
      { value: "Thu" },
      { value: "Fri" },
      { value: "Sat" },
      { value: "Sun" },
      { value: "Mon" },
      { value: "Tue" },
      { value: "Wed" },
    ],
    [
      { value: "1" },
      { value: "Bharani Raj" },
      { value: "7305029137" },
      { value: "G" },
      { value: "G" },
      { value: "A" },
      { value: "C" },
      { value: "G" },
      { value: "OFF" },
      { value: "G" },
      { value: "G" },
      { value: "G" },
      { value: "A" },
      { value: "C" },
      { value: "OFF" },
      { value: "G" },
      { value: "G" },
      { value: "A" },
      { value: "C" },
      { value: "G" },
      { value: "OFF" },
      { value: "G" },
      { value: "G" },
      { value: "A" },
      { value: "C" },
      { value: "OFF" },
      { value: "G" },
    ],
    [
      { value: "2" },
      { value: "JOSE J" },
      { value: "8136999968" },
      { value: "A" },
      { value: "G" },
      { value: "B" },
      { value: "C" },
      { value: "A" },
      { value: "G" },
      { value: "G" },
      { value: "A" },
      { value: "G" },
      { value: "B" },
      { value: "C" },
      { value: "A" },
      { value: "G" },
      { value: "G" },
      { value: "A" },
      { value: "G" },
      { value: "B" },
      { value: "C" },
      { value: "A" },
      { value: "G" },
      { value: "G" },
      { value: "A" },
      { value: "G" },
      { value: "B" },
    ],
    [
      { value: "3" },
      { value: "JITHU M" },
      { value: "9745948873" },
      { value: "C" },
      { value: "A" },
      { value: "G" },
      { value: "B" },
      { value: "C" },
      { value: "A" },
      { value: "G" },
      { value: "C" },
      { value: "A" },
      { value: "G" },
      { value: "B" },
      { value: "C" },
      { value: "A" },
      { value: "G" },
      { value: "C" },
      { value: "A" },
      { value: "G" },
      { value: "B" },
      { value: "C" },
      { value: "A" },
      { value: "G" },
      { value: "C" },
      { value: "A" },
      { value: "G" },
    ],
    [
      { value: "4" },
      { value: "SUNIL ANTONY" },
      { value: "7356688113" },
      { value: "G" },
      { value: "G" },
      { value: "C" },
      { value: "A" },
      { value: "G" },
      { value: "OFF" },
      { value: "B" },
      { value: "G" },
      { value: "G" },
      { value: "C" },
      { value: "A" },
      { value: "G" },
      { value: "OFF" },
      { value: "B" },
      { value: "G" },
      { value: "C" },
      { value: "A" },
      { value: "G" },
      { value: "OFF" },
      { value: "B" },
      { value: "G" },
      { value: "C" },
      { value: "A" },
      { value: "G" },
    ],
    [
      { value: "5" },
      { value: "MAHESH M S" },
      { value: "9497787507" },
      { value: "A" },
      { value: "B" },
      { value: "C" },
      { value: "A" },
      { value: "B" },
      { value: "C" },
      { value: "G" },
      { value: "A" },
      { value: "B" },
      { value: "C" },
      { value: "A" },
      { value: "B" },
      { value: "C" },
      { value: "G" },
      { value: "A" },
      { value: "B" },
      { value: "C" },
      { value: "A" },
      { value: "B" },
      { value: "C" },
      { value: "G" },
      { value: "A" },
      { value: "B" },
      { value: "C" },
    ],
    [
      { value: "6" },
      { value: "ACHU PRAKASH" },
      { value: "7306379185" },
      { value: "G" },
      { value: "OFF" },
      { value: "G" },
      { value: "G" },
      { value: "OFF" },
      { value: "G" },
      { value: "OFF" },
      { value: "G" },
      { value: "OFF" },
      { value: "G" },
      { value: "G" },
      { value: "OFF" },
      { value: "G" },
      { value: "OFF" },
      { value: "G" },
      { value: "OFF" },
      { value: "G" },
      { value: "G" },
      { value: "OFF" },
      { value: "G" },
      { value: "OFF" },
      { value: "G" },
      { value: "G" },
      { value: "OFF" },
      { value: "G" },
    ],
    [
      { value: "7" },
      { value: "AMBADY" },
      { value: "9633949413" },
      { value: "B" },
      { value: "A" },
      { value: "C" },
      { value: "B" },
      { value: "A" },
      { value: "C" },
      { value: "OFF" },
      { value: "B" },
      { value: "A" },
      { value: "C" },
      { value: "B" },
      { value: "A" },
      { value: "C" },
      { value: "OFF" },
      { value: "B" },
      { value: "A" },
      { value: "C" },
      { value: "B" },
      { value: "A" },
      { value: "C" },
      { value: "OFF" },
      { value: "B" },
      { value: "A" },
      { value: "C" },
    ],
    [
      { value: "8" },
      { value: "VIDHUN KUMAR" },
      { value: "7736696799" },
      { value: "C" },
      { value: "C" },
      { value: "C" },
      { value: "B" },
      { value: "C" },
      { value: "B" },
      { value: "OFF" },
      { value: "C" },
      { value: "C" },
      { value: "C" },
      { value: "B" },
      { value: "C" },
      { value: "B" },
      { value: "OFF" },
      { value: "C" },
      { value: "C" },
      { value: "C" },
      { value: "B" },
      { value: "C" },
      { value: "B" },
      { value: "OFF" },
      { value: "C" },
      { value: "C" },
      { value: "C" },
    ],
    [
      { value: "9" },
      { value: "ASHOK M" },
      { value: "8136805384" },
      { value: "G" },
      { value: "NH" },
      { value: "NH" },
      { value: "G" },
      { value: "NH" },
      { value: "NH" },
      { value: "G" },
      { value: "NH" },
      { value: "NH" },
      { value: "G" },
      { value: "NH" },
      { value: "NH" },
      { value: "G" },
      { value: "NH" },
      { value: "NH" },
      { value: "G" },
      { value: "NH" },
      { value: "NH" },
      { value: "G" },
      { value: "NH" },
      { value: "NH" },
      { value: "G" },
      { value: "NH" },
      { value: "NH" },
      { value: "G" },
    ],
    [
      { value: "10" },
      { value: "ARAVIND R S" },
      { value: "8943943326" },
      { value: "G" },
      { value: "OFF" },
      { value: "G" },
      { value: "G" },
      { value: "OFF" },
      { value: "G" },
      { value: "OFF" },
      { value: "G" },
      { value: "OFF" },
      { value: "G" },
      { value: "G" },
      { value: "OFF" },
      { value: "G" },
      { value: "OFF" },
      { value: "G" },
      { value: "OFF" },
      { value: "G" },
      { value: "G" },
      { value: "OFF" },
      { value: "G" },
      { value: "OFF" },
      { value: "G" },
      { value: "G" },
      { value: "OFF" },
      { value: "G" },
    ],
    [
      { value: "11" },
      { value: "SUJITH S S" },
      { value: "9895144121" },
      { value: "G" },
      { value: "NH" },
      { value: "NH" },
      { value: "G" },
      { value: "NH" },
      { value: "NH" },
      { value: "G" },
      { value: "NH" },
      { value: "NH" },
      { value: "G" },
      { value: "NH" },
      { value: "NH" },
      { value: "G" },
      { value: "NH" },
      { value: "NH" },
      { value: "G" },
      { value: "NH" },
      { value: "NH" },
      { value: "G" },
      { value: "NH" },
      { value: "NH" },
      { value: "G" },
      { value: "NH" },
      { value: "NH" },
      { value: "G" },
    ],
    [
      { value: "12" },
      { value: "SIVAKUMAR A" },
      { value: "9895144121" },
      { value: "G" },
      { value: "G" },
      { value: "G" },
      { value: "G" },
      { value: "G" },
      { value: "G" },
      { value: "G" },
      { value: "G" },
      { value: "G" },
      { value: "G" },
      { value: "G" },
      { value: "G" },
      { value: "G" },
      { value: "G" },
      { value: "G" },
      { value: "G" },
      { value: "G" },
      { value: "G" },
      { value: "G" },
      { value: "G" },
      { value: "G" },
      { value: "G" },
      { value: "G" },
      { value: "G" },
      { value: "G" },
    ],
    [
      { value: "13" },
      { value: "SARATH" },
      { value: "7293121668" },
      { value: "G" },
      { value: "OFF" },
      { value: "G" },
      { value: "G" },
      { value: "OFF" },
      { value: "G" },
      { value: "G" },
      { value: "OFF" },
      { value: "G" },
      { value: "G" },
      { value: "OFF" },
      { value: "G" },
      { value: "G" },
      { value: "OFF" },
      { value: "G" },
      { value: "G" },
      { value: "OFF" },
      { value: "G" },
      { value: "G" },
      { value: "OFF" },
      { value: "G" },
      { value: "G" },
      { value: "OFF" },
      { value: "G" },
      { value: "G" },
    ],
    [
      { value: "13" },
      { value: "KAMARUDHEEN" },
      { value: "8893199885" },
      { value: "G" },
      { value: "G" },
      { value: "G" },
      { value: "G" },
      { value: "OFF" },
      { value: "G" },
      { value: "G" },
      { value: "G" },
      { value: "G" },
      { value: "G" },
      { value: "OFF" },
      { value: "G" },
      { value: "G" },
      { value: "G" },
      { value: "OFF" },
      { value: "G" },
      { value: "G" },
      { value: "G" },
      { value: "OFF" },
      { value: "G" },
      { value: "G" },
      { value: "G" },
      { value: "OFF" },
      { value: "G" },
      { value: "G" },
    ],
  ]);

  const handleDownload = () => {
    const aoaData = ShiftUpload.map((row) => row.map((cell) => cell.value));
    if (ShiftUpload.length === 0) {
      console.error("No data to download");
      return;
    }

    // Check if aoaData is correctly created
    if (aoaData.length === 0 || aoaData[0].length === 0) {
      console.error("AoA Data is empty or incorrectly formatted:", aoaData);
      return;
    }

    // Create a new workbook and a worksheet
    const ws = XLSX.utils.aoa_to_sheet(aoaData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    // Write the workbook to a buffer
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    console.log("Excel Buffer:", new Uint8Array(excelBuffer)); // Debugging line

    // Create a Blob from the buffer and save it as an Excel file
    try {
      const blob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, `shift.xlsx`);
      console.log("File saved successfully");
    } catch (error) {
      console.error("Error creating Blob or saving file:", error);
    }
  };

  const [searchSuperviorsSlice,setsearchSuperviorsSlice] = useState(
        TablePositionPersist?.Supervisor_empDatas?.search == undefined ||
        TablePositionPersist?.Supervisor_empDatas?.search == ""
          ? ''
          : TablePositionPersist?.Supervisor_empDatas?.search
      );  
      
      
  const [DeleteIDSuperviorsSlice, setDeleteIdSuperviorsSlice] = useState();
  const [DeletePopupSuperviorsSlice, setDeletePopupSuperviorsSlice] =
    useState(false);
  const [UserCreateSuperviorsSlice, setUserCreateSuperviorsSlice] =
    useState(false);
  const [UserEditPopupSuperviorsSlice, setUserEditPopupSuperviorsSlice] =
    useState(false);
  const [EditIdSuperviorsSlice, setEditIDSuperviorsSlice] = useState();
  const [dtpageindexSuperviorsSlice, setdtPageindexSuperviorsSlice] =
    useState(1);
  const [dtpagesizeSuperviorsSlice, setdtPagesizeSuperviorsSlice] =
    useState(20);
  const [pageSizeSuperviorsSlice, setPageSizeSuperviorsSlice] = useState(10);
  const [newpagesSuperviorsSlice, setNewpageSuperviorsSlice] = useState();


      const [currentPageSuperviorsSlice, setCurrentPageSuperviorsSlice] = useState(
      TablePositionPersist?.Supervisor_empDatas?.page == undefined
        ? 1
        : TablePositionPersist.Supervisor_empDatas.page
    );

    const [TypeOfsuperviors, setTypeofSupervior] = useState({
    value: "add",
    label: "added supervisor",
  });
  const [StatusRenderSuper, setStatusRenderSuper] = useState(false);
  const supervisoreOptions = [
    { value: "add", label: "added supervisor" },
    { value: "remove", label: "removed supervisor" },
  ];
  const superviorChanges = (e) => {
    setTypeofSupervior(e);
  };

  ///--Superviors-----
  useEffect(() => {
    if (state.clientDetailsCall.ActiveClinetTabs == 5) {
      const payload = {
        search: searchSuperviorsSlice,
        page_size: 20,
        // page: dtpageindexSuperviorsSlice,
        page: currentPageSuperviorsSlice,

        client_id: state.ClientBranchIDs.clientBranchEditView,
        // type: TypeOfsuperviors.value,
        type: "remove",
      };
      dispatch(SetTheSuperviorsListACtions(payload));
                                  dispatch(
                  setTablePositionPersist({ data: payload, pageName: "Supervisor_empDatas" })
                );
    }
  }, [
    state.clientDetailsCall.ActiveClinetTabs,
    // TypeOfsuperviors,
    // SuperviorsState,
    // StatusRenderSuper
    // dtpageindexSuperviorsSlice,
    searchSuperviorsSlice,
    currentPageSuperviorsSlice ,
  ]);

  const pageSuperviorsSlicesize = (arg) => {
    setdtPagesizeSuperviorsSlice(arg);
  };

  const pageSuperviorsSliceindex = (arg) => {
    setdtPageindexSuperviorsSlice(arg);
  };

  //---
  const handleSuperviorsSlicePrevious = (previous) => {
    if (previous != 0) {
      setCurrentPageSuperviorsSlice(previous);
    }
  };

  const GotoEnteredPageSupervisor =(gotopage)=>{
    setCurrentPageSuperviorsSlice(gotopage)
  }



  const handleSuperviorsSliceNext = (next) => {
      setCurrentPageSuperviorsSlice(next + 1);
      setNewpageSuperviorsSlice(next + 1);

    
  };




  const debouncedSearch = useMemo(
    () =>
      _.debounce((e) => {
    setsearchSuperviorsSlice(e);

      }, 500),
    []
  );

  function tochangeSuperviorsSlice(e) {
    setCurrentPageSuperviorsSlice(1)
    debouncedSearch(e);
  }

  React.useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);


  ///---handel the removed supervisor
  const HandleTheRemovedSupervior = (e) => {
    const payload = {
      data: {
        user_list: [e],
        type: "remove",
      },
      page: dtpageindexSuperviorsSlice,
      search: searchSuperviorsSlice,
      client_id: state.ClientBranchIDs.clientBranchEditView,

    };
    dispatch(setTheSuperviorsgeteListActions(payload));
    setStatusRenderSuper(!StatusRenderSuper);
  };


  const columnSuperviorss = useMemo(
    () => [
      {
        Header: "Tnx Id",
        accessor: "",
        Cell: (row) => {
           if(row.row.original.user_id.id != undefined && row.row.original.user_id.id != null){ 
          const userId = row.row.original.user_id.id;
          const lastFourDigits = userId.slice(-6);
          return <p>{lastFourDigits}</p>; 
           }
        },
      },
      {
        Header: " Name",
        accessor: "",
        Cell: (row) => {
          //   console.log(row.row.original, "sdflsd");
          return (
            <>
              <div className="UserName" style={{ cursor: "pointer" }}>
                <div className="">
                  <span>{row.row.original.user_id.first_name}</span>
                </div>
              </div>
            </>
          );
        },
      },

      {
        Header: "Email",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              {row.row.original.user_id.email != undefined &&
              row.row.original.user_id.email != null &&
              row.row.original.user_id.email != "" ? (
                <span>{row.row.original.user_id.email}</span>
              ) : (
                <span>{"--"}</span>
              )}
            </>
          );
        },
      },

      {
        Header: "Role",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              {row.row.original.user_id.user_role != undefined &&
              row.row.original.user_id.user_role.role != undefined ? (
                <span>{row.row.original.user_id.user_role.role}</span>
              ) : (
                <span>{"--"}</span>
              )}
            </>
          );
        },
      },

      {
        Header: "Created Date",
        accessor: "",
        Cell: (row) => {
          const dateString = row.row.original.created_at;
          const dateObject = new Date(dateString);
          const hours = dateObject.getHours();
          const minutes = dateObject.getMinutes();
          const seconds = dateObject.getSeconds();
          const amOrPm = hours >= 12 ? "PM" : "AM";
          const twelveHourFormat = hours % 12 || 12;
          const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

          const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;
          return (
            <>
              <span>
                {row.row.original.created_at != undefined &&
                row.row.original.created_at != null
                  ? `${
                      row.row.original.created_at.slice(0, 10) +
                      "  " +
                      formattedTime
                    }`
                  : "---"}
              </span>
            </>
          );
        },
      },

      {
        Header: "Actions",
        accessor: "",
        Cell: (row) => {
          const [showTooltip, setShowTooltip] = useState(false);

          return (
            <>
              <div
                class="actions"
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  gap: "5px",
                }}
              >
                {row.row.original.user_id &&
                row.row.original.user_id != undefined &&
                row.row.original.user_id != null &&
                row.row.original.user_id.id !=""
                &&
                row.row.original.user_id.id != undefined &&
                row.row.original.user_id.id != null &&
                row.row.original.user_id.first_name &&
                row.row.original.id != null ? (
                  <button
                    style={{
                      background: "#F7EAE6",
                      borderRadius: "50%",
                      padding: "1px",
                      marginLeft: "12px",
                      width: "27px",
                      zIndex: "0",
                      position: 'relative',
                      display:"flex",
                      justifyContent:"center",
                      alignItems:"center",
                      outline:"none"
                    }}

                    onClick={(e) => {
                      HandleTheRemovedSupervior(row.row.original.user_id.id);
                    }}
                    onMouseEnter={() => setShowTooltip(true)} 
                    onMouseLeave={() => setShowTooltip(false)}
        
                  >
                    <span  className="EditImages" style={{width:"12px",height:"21px"}}>
                    <img src={Xmark}/>
                    </span>
                    {showTooltip && (
              <div className="custom-tooltip-branch">
                {"Remove Supervisor"}
              </div>
            )}

                  </button>
                ) : (
                  <span>---</span>
                )}
              </div>
            </>
          );
        },
      },
    ],
    [sno]
  );

  //   const [selectedDates, setSelectedDates] = useState();
  //   var today = new Date();
  //   var prioiDate = new Date(new Date().setDate(today.getDate() - 30));
  //   // console.log(String(today) );
  //   var it = String(today);
  //   var gt = String(prioiDate);
  //   // console.log(it, gt);
  //   const [range, setrange] = useState([gt, it]);
  // const getCurrentAndNextMonthDates = () => {
  //   const currentDate = new Date();
  //   const currentMonth = currentDate.getMonth() + 1;
  //   const currentYear = currentDate.getFullYear();
  //   const currentdate = currentDate.getDate()
  //   const nextMonthDate = new Date(currentYear, currentMonth);
  //   nextMonthDate.setMonth(nextMonthDate.getMonth() + 1);

  //   const currentMonthFormatted = `${currentYear}-${String(currentMonth).padStart(2, '0')}-${currentdate}`;
  //   const nextMonthFormatted = `${nextMonthDate.getFullYear()}-${String(nextMonthDate.getMonth() + 1).padStart(2, '0')}-${}`;

  //   return { currentMonth: currentMonthFormatted, nextMonth: nextMonthFormatted };
  // }

  //   const getCurrentAndNextMonthDates = () => {
  //     const currentDate = new Date();
  //     const currentMonth = currentDate.getMonth() + 1;
  //     const currentYear = currentDate.getFullYear();
  //     const currentdate = currentDate.getDate()
  //     const nextMonthDate = new Date(currentYear, currentMonth);
  //     nextMonthDate.setMonth(nextMonthDate.getMonth() + 1);

  //     const currentMonthFormatted = `${currentYear}-${String(currentMonth).padStart(2, '0')}-${currentdate}`;

  //     // Get the last date of the next month
  //     const nextMonthLastDate = new Date(nextMonthDate.getFullYear(), nextMonthDate.getMonth() , 0);
  //     const nextMonthFormatted = `${nextMonthDate.getFullYear()}-${String(nextMonthDate.getMonth() + 1).padStart(2, '0')}-${nextMonthLastDate.getDate()}`;

  //     return { currentMonth: currentMonthFormatted, nextMonth: nextMonthFormatted };
  // }

  // const getCurrentAndNextMonthDates = () => {
  //   const currentDate = new Date();
  //   const currentMonth = currentDate.getMonth() + 1;
  //   const currentYear = currentDate.getFullYear();
  //   const currentdate = currentDate.getDate();

  //   const nextMonthDate = new Date(currentYear, currentMonth - 1); // Subtract 1 from currentMonth
  //   nextMonthDate.setMonth(nextMonthDate.getMonth() + 1);

  //   const currentMonthFormatted = `${currentYear}-${String(
  //     currentMonth
  //   ).padStart(2, "0")}-${currentdate}`;

  //   // Get the last date of the next month
  //   const nextMonthLastDate = new Date(
  //     nextMonthDate.getFullYear(),
  //     nextMonthDate.getMonth() + 1,
  //     0
  //   );
  //   const nextMonthFormatted = `${nextMonthDate.getFullYear()}-${String(
  //     nextMonthDate.getMonth() + 1
  //   ).padStart(2, "0")}-${nextMonthLastDate.getDate()}`;

  //   return {
  //     currentMonth: currentMonthFormatted,
  //     nextMonth: nextMonthFormatted,
  //   };
  // };

  // // Usage
  // var { currentMonth, nextMonth } = getCurrentAndNextMonthDates();

  const getCurrentMonthStartAndEndDate = () => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1;
    const firstDateOfMonth = new Date(currentYear, currentMonth - 1, 1);
    const lastDateOfMonth = new Date(currentYear, currentMonth, 0);

    const startDatemon = `${currentYear}-${String(currentMonth).padStart(
      2,
      "0"
    )}-${String(firstDateOfMonth.getDate()).padStart(2, "0")}`;
    const endDatemon = `${currentYear}-${String(currentMonth).padStart(
      2,
      "0"
    )}-${String(lastDateOfMonth.getDate()).padStart(2, "0")}`;

    return {
      startDatemon,
      endDatemon,
    };
  };

  var { startDatemon, endDatemon } = getCurrentMonthStartAndEndDate();

  const [data, setdata] = useState({
    from_date: startDatemon,
    to_date: endDatemon,
    range: false,
    base_type: "day",
  });

  const Options = [
    {
      id: 1,
      value: "day",
      label: "DAY",
    },
    {
      id: 2,
      value: "time",
      label: "TIME",
    },
  ];

  const HandleChanges = (e) => {
    //    console.log(e.target.value, "sdfsdgfweifi");

    setdata({ ...data, base_type: e.target.value });
  };

  //   //----Handle----Date=-----Changes---
  //   const handlechangedate = (value, d) => {
  //     console.log(value , d , "values");
  //     if (value != null) {
  //       setrange((oldArray) => [...oldArray, d.slice(0, 10)]);

  //       setdata((prevData) => ({
  //         ...prevData,
  //         [value]: d.slice(0, 10), // Update the 'from_date' or 'to_date' property
  //       }));
  //     }
  //     console.log(range, "range", data);
  // };

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [focusedInput, setFocusedInput] = useState(null);

  // const handleDatesChange = ({ startDate, endDate }) => {
  //   setStartDate(startDate);
  //   setEndDate(endDate);
  // };

  const [selectedDates, setSelectedDates] = useState([]);
  const [datestae, setdatest] = useState(false);
  const formattedDates =
    selectedDates != null &&
    selectedDates.map((date) => {
      const isoString = date.toISOString();
      return isoString.substring(0, 10);
    });

  const handleDateChange = (e) => {
    if (e != null) {
      setdatest(true);
      setSelectedDates(e);
      e.forEach((newValue) => {
        const tzoffset = new Date().getTimezoneOffset() * 60000;
        const localISOTime = new Date(newValue - tzoffset)
          .toISOString()
          .slice(0, -1);
        // handle the start and end dates here
      });
    }
  };

  useEffect(() => {
    if (datestae) {
      setdata({
        ...data,
        from_date: formattedDates[0],
        to_date: formattedDates[1],
        range: true,
      });
    }
  }, [selectedDates]);





  const handleChange = (e) => {
  }

  ///--attendance--export------------------
  useEffect(() => {
    if (
      state.ClientBranchIDs.clientBranchEditView != undefined &&
      state.clientDetailsCall.ActiveClinetTabs == 1
    ) {
      const payloads = {
        search: search,
        page_size: 20,
        page: currentPageShift,
        client_id: state.ClientBranchIDs.clientBranchEditView,
        // client_id: state.ClientBranchIDs.ClientBranchID,
      };

      dispatch(SetShiftSearchActions(payloads));
      dispatch(
                  setTablePositionPersist({ data: payloads, pageName: "Shift_empDatas" })
                );
      setShitfs(state.ShiftSearch.ShiftSearch);
      //  console.log(state.ClientBranchIDs.clientBranchEditView, "idfd");
    }
    // console.log(
    // state.BranchRetrieve.BranchesRetrieve.id,
    // "CLientsss Branch IDS",
    // state.ShiftSearch.ShiftSearch
    // );
  }, [state.clientDetailsCall.ActiveClinetTabs , search]);

  useEffect(() => {
    if (state.ClientBranchIDs.clientBranchEditView != undefined) {
      setShitfs(state.ShiftSearch.ShiftSearch);
      // console.log(
      //   state.ShiftSearch.ShiftSearch,
      //   "SHiftSearchedONE",
      //   state.ClientBranchIDs
      // );
    }
  }, []);


  const handlePrevious = (previous) => {
    if (previous != 0) {
      setCurrentPage(previous);
      
    }
  };
  const handleNext = (next) => {
      setCurrentPage(next + 1);

    
  };

  const GotoEnteredPage =(gotopage)=>{
    setCurrentPage(gotopage)
  }

  const pagesize = (arg) => {
    setdtPagesize(arg);
  };

  const pageindex = (arg) => {
    setdtPageindex(arg);
  };

  const debouncedshift = useMemo(
    () =>
      _.debounce((e) => {
          setsearch(e);

      }, 500),
    []
  );

  // -----Search------------------------
  function tochange(e) {
    debouncedshift(e);
        setCurrentPage(1)


  }

  React.useEffect(() => {
    return () => {
      debouncedshift.cancel();
    };
  }, [debouncedshift]);


  const HandelDelete = () => {
        setsearch("");
    setCurrentPageshift(1)

    if (DeleteID != undefined) {
      const payload = {
        DeleteID: DeleteID,
        currentPageShift: 1,
        client_id: state.ClientBranchIDs.clientBranchEditView,
      };
      dispatch(setShiftDeletCall(payload, setDeletePOPUP(false)));
    }
  };

  const columns = [
    {
      Header: "Shift",
      accessor: "shift_name",
    },
    {
      Header: "Start Time ",
      accessor: "from_time ",
      Cell: (row) => {
        return (
          <>
            <div className="Create-Date">
              <div
                style={{ marginTop: "3px" }}
                // data-tooltip-id="Name-ToolTips"
                // data-tooltip-content={String(row.row.original.from_time)}
              >
                {/* <span> */}
                {/* {" "} */}
                {/* {String(row.row.original.from_time.split("T")[0])}{" "} */}
                {/* </span> */}
                <span> {String(row.row.original.from_time)} </span>
              </div>
            </div>
          </>
        );
      },
    },

    {
      Header: "Excel Code",
      accessor: "excel_code",
      Cell: (row) => {
        return (
          <>
            <>
              {row.row.original.excel_code != " " &&
              row.row.original.excel_code != undefined ? (
                <span>{row.row.original.excel_code}</span>
              ) : (
                <span>{"---"}</span>
              )}
            </>
          </>
        );
      },
    },

    {
      Header: "End Time ",
      accessor: "end_time ",
      Cell: (row) => {
        return (
          <>
            <div className="Create-Date">
              <div
                style={{ marginTop: "3px" }}
              >

                <span> {String(row.row.original.end_time)} </span>
              </div>
            </div>
          </>
        );
      },
    },

    {
      Header: "Created date",
      accessor: "",
      Cell: (row) => {
        const dateString = row.row.original.created_at;
        const dateObject = new Date(dateString);
        const hours = dateObject.getHours();
        const minutes = dateObject.getMinutes();
        const seconds = dateObject.getSeconds();
        const amOrPm = hours >= 12 ? "PM" : "AM";
        const twelveHourFormat = hours % 12 || 12;

        const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

        const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;

        return (
          <>
            <div className="CreatedDatelisted"
            // data-tooltip-id="Name-ToolTips"
            // data-tooltip-content={`${formattedTime}`}
            >
              {`${
                row.row.original.created_at.slice(0, 10) }`}
            </div>
          </>
        );
      },
    },

    {
      Header: "Actions",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div
              class="actions"
              style={{
                display: "flex",
                justifyContent: "flex-start",
                gap: "5px",
              }}
            >
              <button
                className=" btn Status"
                component="span"
                onClick={(e) => {
                  setEditID(row.row.original.id);
                  setEditpopup(true);
                }}
              >
                <span className="OuterActionSpan">
             
                     <span  className="EditImages">
                    <img src={EditImages}/>
                  </span>
                  <span className="ActionsList"> Edit </span>
                </span>
              </button>

              <button
                type="button"
                class="btn Status"
                onClick={(e) => {
                  setDeleteID(row.row.original.id);
                  setDeletePOPUP(true);
                }}
              >
                <span className="OuterActionSpan">
                  {/* <i
                    class="fa-regular fa-trash-can"
                    style={{
                      fontSize: "15px",
                      paddingRight: "3px",
                      paddingBottom: "3px",
                    }}
                  ></i> */}
                  <span  className="EditImages">
                    <img src={DeleteImages}/>
                  </span>
                  
                  <span className="ActionsList"> Delete </span>
                </span>
              </button>
            </div>
          </>
        );
      },
    },
  ];

  ////--------------------------Emp Inquriy----------FUnctionality
  const [dtpageindexEMp, setdtPageindexEMP] = useState(1);
  const [dtpagesizeEmp, setdtPagesizeEMp] = useState(10);
  const [pageSizeEMP, setPageSizeEMp] = useState(10);
  const [searchEmp, setsearchEMP] = useState("");
  const [newpagesEmp, setNewpageEMP] = useState(1);
  const [currentPageEmp, setcurrentPageemp] = useState(1);

  const [DeleteIDEMP, SetDeleteEmpID] = useState("");
  const [DeleteEmpPOPUP, setDeletePOPUPEMp] = useState(false);
  const [EditIdEmp, setEditId] = useState("");
  const [EditPopupEmp, setsetEditEmpPOPUP] = useState(false);
  const [EmpCreatepopup, setCreateEmpPopup] = useState(false);
  const [MakeCreateEmp, setCreateBarStatus] = useState(true);


  ///-----Client---Branch---Edit
  const [BranchEditid, setEditBranchID] = useState("");
  const [EditBranchPOPUP, setEditPopupBranch] = useState(false);
  useEffect(() => {
    if (state.ClientBranchIDs.clientBranchEditView != undefined) {
      setEditBranchID(state.ClientBranchIDs.clientBranchEditView);
      // console.log(
      // EditBranchPOPUP,
      // "test",
      // state.ClientBranchIDs.clientBranchEditView
      // );
    }
  }, [state.ClientBranchIDs.clientBranchEditView]);

  useEffect(() => {
    if (state.ClientBranchIDs.clientBranchEditView != undefined) {
      const payload = {
        EditId: state.ClientBranchIDs.clientBranchEditView,
      };
      dispatch(setClientBranchesRetrieveActions(payload));
      // console.log(
      // state.BranchRetrieve.BranchesRetrieve,
      // "stae8080" ,

      // );
    }
    //console.log(state.BranchRetrieve.BranchesRetrieve, "wetgesdv");
  }, [state.ClientBranchIDs.clientBranchEditView]);


  function Counting(value) {
    setCount(value);
    return Counting;
  }
console.log(state.clientDetailsCall.CreateActive ," state.clientDetailsCall.CreateActive");

  const HandleClicks = () => {
    if (state.clientDetailsCall.CreateActive == 1) {
      // console.log("Shift", Counts);
      ////---For-----The--Shifts
      setShiftCreatePopup(true);
      setEditID("");
    } else if (state.clientDetailsCall.CreateActive == 4) {
      setExcelSheetPo(true);
      /// console.log("Emp", Counts);
      // RouteHoldClient();
    } else if (state.clientDetailsCall.CreateActive == 5) {
      setSuperviorsState(true);
    } else {
    }
  };

  function capital_letter(str) {
    if (str !== undefined && str !== null) {
      str = str.split(" ");
  
      for (var i = 0; i < str.length; i++) {
        if (str[i]) {
          str[i] = str[i][0].toUpperCase() + str[i].substr(1);
        }
      }
  
      return str.join(" ");
    } else {
      return "--";
    }
  }


  ////---Leave---Status----

  const [dtpageindexLevae, setdtPageindexLeave] = useState(
      TablePositionPersist?.Leave_empDatas?.page == undefined
        ? 1
        : TablePositionPersist.Leave_empDatas.page
    );

  const [dtpagesizeLeave, setdtPagesizeLeve] = useState(20);
  const [pageSizeLeave, setPageSizeLeave] = useState(10);
  const [newpagesLeave, setNewpageLeba] = useState(1);
  const [searchLeabe,setsearchLeave] = useState(
        TablePositionPersist?.Leave_empDatas?.search == undefined ||
        TablePositionPersist?.Leave_empDatas?.search == ""
          ? ''
          : TablePositionPersist?.Leave_empDatas?.search
      );  
      
    const [LeaveData, setLeavedatas] = useState([]);
  const [currentPageLeave, setCurrentPageLeave] = useState(1);

  useEffect(() => {
    if (state.clientDetailsCall.ActiveClinetTabs == 3) {
      const payload = {
        search: searchLeabe,
        // page_size: dtpagesizeLeave,
        page_size:20,

        page: dtpageindexLevae,
        client_id: state.ClientBranchIDs.clientBranchEditView,
        user: "",
      };
      dispatch(getLeaveStatusPersonsListed(payload));
                           dispatch(
                  setTablePositionPersist({ data: payload, pageName: "Leave_empDatas" })
                );
    }
  }, [state.clientDetailsCall.ActiveClinetTabs, dtpageindexLevae , searchLeabe]);

  const HandleDownloadLeaveStatus = (documents) => {
    window.open(documents);
  };
  ///-----__Leave----------Employees--------------

  const LeaveColumn = [
    {
      Header: "Name",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <span>{row.row.original.user_id.first_name}</span>
          </>
        );
      },
    },
    {
      Header: "From",
      accessor: "from_date",
    },
    {
      Header: "To",
      accessor: "to_date",
    },
    {
      Header: "Note",
      accessor: "notes",
    },
    ///------Leave---document-----uploads
    {
      Header: "Reason",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div className="LeaveStatusBtn">
              {row.row.original.leave_type != null &&
              row.row.original.leave_type.leave_type != undefined ? (
                <span>{row.row.original.leave_type.leave_type}</span>
              ) : (
                <span>{"---"}</span>
              )}

              {row.row.original.certificate_id != undefined &&
              row.row.original.certificate_id.media_url != undefined ? (
                <button
                  type="button"
                  class="btn "
                  onClick={(e) => {
                    HandleDownloadLeaveStatus(
                      row.row.original.certificate_id.media_url
                    );
                  }}
                >
                  <img src={downloadoffer} alt="Download Offer Letter" />
                  </button>
              ) : (
                <span>{""}</span>
              )}
            </div>
          </>
        );
      },
    },
    {
      Header: "Status",
      accessor: "status",
      Cell: (row) => {
        const originalString = row.row.original.status;
        const capitalizedString = capitalizeFirstLetter(originalString);
        return (
          <>
            {row.row.original.status != undefined ? (
              <>
                {row.row.original.status.toLowerCase() == "pending" ? (
                  <div className="StatusList">
                    <img src={Pendingimg} />
                    <span>{capitalizedString}</span>
                  </div>
                ) : (
                  <>
                    {row.row.original.status.toLowerCase() == "decline" ? (
                      <div className="StatusList">
                        <div className="DeclineStatus">
                          <span>x</span>
                        </div>
                        <span>{capitalizedString}</span>
                      </div>
                    ) : (
                      <>
                        {row.row.original.status.toLowerCase() == "approved" ? (
                          <div className="StatusList">
                            <img src={correctIcons} />
                            <span>{capitalizedString}</span>
                          </div>
                        ) : null}
                      </>
                    )}
                  </>
                )}
              </>
            ) : (
              <span>---</span>
            )}
          </>
        );
      },
    },
  ];

  const debouncedLeave = useMemo(
    () =>
      _.debounce((e) => {
         setsearchLeave(e);
      }, 500),
    []
  );

  function tochangeLeave(e) {
    // console.log("ee", e);
        setdtPageindexLeave(1)

    debouncedLeave(e);

  }

  React.useEffect(() => {
    return () => {
      debouncedLeave.cancel();
    };
  }, [debouncedLeave]);


  const handleNextLeave = (next) => {
    
    setdtPageindexLeave(next + 1);

    
  };

  const handlePreviousLeave = (previous) => {
      setdtPageindexLeave(previous);

  };


  const GotoPageEnteredLeave = (previous) => {
    setdtPageindexLeave(previous);

};

 

  
  const pagesizeLevae = (arg) => {
    setdtPagesizeLeve(arg);
  };
  const pageindexLeave = (arg) => {
    //  console.log(arg, "args");
    setdtPageindexLeave(arg);
  };

  /////-----------------___Excel---Sheet----Uploads---Get--LIST-----------------
  const [dtpageindexExcel, setdtPageindexexcel] = useState(1);
  const [dtpagesizeecel, setdtPagesizeexcel] = useState(10);
  const [pageSizeexcel, setPageSizexcel] = useState(20);
  const [newpagesexcel, setNewpageexcel] = useState(1);

  const [searchexcel,setsearchexcel] = useState(
        TablePositionPersist?.ShiftUpload_empDatas?.search == undefined ||
        TablePositionPersist?.ShiftUpload_empDatas?.search == ""
          ? ''
          : TablePositionPersist?.ShiftUpload_empDatas?.search
      );  

       const [currentPageEXcel, setCurrentPageExcel] = useState(
      TablePositionPersist?.ShiftUpload_empDatas?.page == undefined
        ? 1
        : TablePositionPersist.ShiftUpload_empDatas.page
    );

  ///----Shift-------Upload----get------------------
  useEffect(() => {
     console.log(state.clientDetailsCall.ActiveClinetTabs ,"owieActiveClinetTabs" );
     
    if (state.clientDetailsCall.ActiveClinetTabs == 4) {
      const payload = {
        search: searchexcel,
        // page_size: 10,
        page_size: 20,

        page:currentPageEXcel,
        client_id: state.ClientBranchIDs.clientBranchEditView,
        user: "",
        
      };
      dispatch(getShiftStatusPersonsListed(payload));
                                  dispatch(
                  setTablePositionPersist({ data: payload, pageName: "ShiftUpload_empDatas" })
                );
      // console.log(state.ShfitData.Shiftdatas, "dauysfda Total_Count");
    }
  }, [state.clientDetailsCall.ActiveClinetTabs , currentPageEXcel  ,searchexcel]);

  const handlePreviousExcelSheet = (previous) => {
      setCurrentPageExcel(previous);
  };
  const handleNextexcelsheet = (next) => {
      setCurrentPageExcel(next + 1);
  };
   const GotoEnteredPageExcelPage=(page)=>{
    setCurrentPageExcel(page);

   }
  const pagesizeexcel = (arg) => {
    setdtPagesizeexcel(arg);
  };
  const pageindexexcel = (arg) => {
    setdtPageindexexcel(arg);
  };

  const debouncedSheetupload = useMemo(
    () =>
      _.debounce((e) => {
    setsearchexcel(e);
      }, 500),
    []
  );

  // -----Search------------------------
  function tochangeshiftExcel(e) {
       setCurrentPageExcel(1)

    debouncedSheetupload(e);

  }

  React.useEffect(() => {
    return () => {
      debouncedSheetupload.cancel();
    };
  }, [debouncedSheetupload]);

  const columnShift = [
    {
      Header: "Name",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.user_id.first_name ? (
              <span>{row.row.original.user_id.first_name}</span>
            ) : (
              <span>{"---"}</span>
            )}
          </>
        );
      },
    },
    {
      Header: "Month",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.month ? (
              <spn>{row.row.original.month}</spn>
            ) : (
              <span>{"---"}</span>
            )}
          </>
        );
      },
    },
    {
      Header: "Year",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.year ? (
              <spn>{row.row.original.year}</spn>
            ) : (
              <span>{"---"}</span>
            )}
          </>
        );
      },
    },
    {
      Header: "Month Start",
      accessor: "",
      Cell: (row) => {
        const dateString = row.row.original.month_start;
        const dateObject = new Date(dateString);
        const hours = dateObject.getHours();
        const minutes = dateObject.getMinutes();
        const seconds = dateObject.getSeconds();
        const amOrPm = hours >= 12 ? "PM" : "AM";
        const twelveHourFormat = hours % 12 || 12;
        const formattedTime = `${twelveHourFormat}:${minutes} ${amOrPm}`;
        return (
          <>
            {row.row.original.month_start ? (
              <span>{`${
                row.row.original.month_start.slice(0, 10) + "  " + formattedTime
              }`}</span>
            ) : (
              <span>{"---"}</span>
            )}
          </>
        );
      },
    },
    {
      Header: "Month End",
      accessor: "",
      Cell: (row) => {
        const dateString = row.row.original.month_end;
        const dateObject = new Date(dateString);
        const hours = dateObject.getHours();
        const minutes = dateObject.getMinutes();
        const seconds = dateObject.getSeconds();
        const amOrPm = hours >= 12 ? "PM" : "AM";
        const twelveHourFormat = hours % 12 || 12;
        const formattedTime = `${twelveHourFormat}:${minutes} ${amOrPm}`;
        return (
          <>
            {row.row.original.month_end ? (
              <span>{`${
                row.row.original.month_end.slice(0, 10) + "  " + formattedTime
              }`}</span>
            ) : (
              <span>{"---"}</span>
            )}
          </>
        );
      },
    },
    {
      Header: "Leave Counts",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.leave_count ? (
              <span>{row.row.original.leave_count}</span>
            ) : (
              <span>{"---"}</span>
            )}
          </>
        );
      },
    },
  ];

  const handleCalenders = (e) => {
    /// console.log(e.id ,"IDS" , e.user_id.id    );
    dispatch(setTheShiftExcelSheetIDS(e));

    if (state.ClientBranchIDs.ShiftExcelsheetID?.id == e.id) {
      navigate("/calender");
    }
  };

  const attendanceexport = (e, statement, values) => {
    console.log(values, statement, e, "auysfdyasdlas");
    Swal.fire({
      title: `Are you sure, do you want to export the attendance  ${
        statement ? "based on this month to end of the  month" : ""
      }?`,
      text: "You won't be able to revert this",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#f26639",
      cancelButtonColor: "#F69338",
      confirmButtonText: "Yes, Export it!",
    }).then((result) => {
      if (result.isConfirmed) {
        const payloads = {
          export_type: values,
          client_id: state.ClientBranchIDs.clientBranchEditView,
          user_id: "",
          data: data,
        };
        dispatch(StetheAttendanceExportActions(payloads));
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.close();
      }
    });
  };

  console.log(state.NeededdatasListed.BranchNameListed, "BranchNameListed");
  const [TabNmaes, setTabnames] = useState({ clientname: "", branchname: "" });
  useEffect(() => {
    if (
      state.NeededdatasListed.clientNameList &&
      typeof state.NeededdatasListed.clientNameList === "string"
    ) {
      const maxLength = 10; // Set your desired maximum length
      const ellipsis = "..."; // Set your ellipsis string

      const truncatedClientName =
        state.NeededdatasListed.clientNameList.length > maxLength
          ? `${state.NeededdatasListed.clientNameList.substring(
              0,
              maxLength
            )}${ellipsis}`
          : state.NeededdatasListed.clientNameList;
      console.log("Truncated Client Name:", truncatedClientName);

      const truncatedBranchNameName =
        state.NeededdatasListed.BranchNameListed.length > maxLength
          ? `${state.NeededdatasListed.BranchNameListed.substring(
              0,
              maxLength
            )}${ellipsis}`
          : state.NeededdatasListed.BranchNameListed;

      setTabnames({
        ...TabNmaes,
        clientname: truncatedClientName,
        branchname: truncatedBranchNameName,
      });
      // Use `truncatedClientName` in your component
      console.log("Truncated Client Name:", truncatedClientName);
    } else {
      // Handle the case when clientNameList is undefined or not a string
      console.log("Client Name List is undefined or not a string");
    }
  }, [state.NeededdatasListed]);

  return (
    <>
      <div className="Details">
        <div className={stateDisplay ? " POPUP" : "outerPOPUP"}>
          <div className="Header-Details ClientBranch row">
            <div
              // className="InnerUsers"
              class="col-sm-7 auto"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                justifyContent: "flex-start",
              }}
            >
              <h3 >Profile</h3>

            </div>

            <div
              className={`Add-User col-sm-5 clientdetails ${
                Counts == 2 ? "hidden" : "DisplayCreate"
              }`}

              style={{ display: "flex", gap: "30px" }}
            >
              {state.clientDetailsCall.ActiveClinetTabs == 4 ? (
                <button onClick={(e) => handleDownload()} className="ButtonCSS">
                  Preview
                </button>
              ) : null}

              <button
                className={` ButtonCSS ${
                  state.clientDetailsCall.CreateActive == 2
                    ? "hidden"
                    : "DisplayCreate"
                }`}
                onClick={(e) => {
                  if (state.clientDetailsCall.CreateActive != 2) {
                    HandleClicks();
                  }
                }}
              >
                {/* {Counts == 5
                  ? "Create Supervisor"
                  : Counts == 4
                  ? "Upload Sheet"
                  : "Create Shift"} */}

                {state.clientDetailsCall.CreateActive == 5
                  ? "Create Supervisor"
                  : state.clientDetailsCall.CreateActive == 4
                  ? "Upload Sheet"
                  : "Create Shift"}

                {/* { Counts == 4
                  ? "Upload Sheet"
                  : "Create Shift"} */}
              </button>
            </div>
          </div>

          <div
            className="row Filters ButtonPrevious"

            style={{ marginLeft: "-17px" }}
          >
            <div className="col">
              <button
                className="btn BackImga"
                onClick={(e) => {
                  navigate("/clientbranch");
                }}
              >
                  <img  className="PreviousPages" src={BackImage}/>
                  <span></span>
              </button>
            </div>
          </div>

          <div className="row ProfileFile">
            <div className="col-md-12">
              <div className="row">
     
              </div>
              <div class="profile-header">
                <div
                  class="row  align-items-center"
                  style={{ padding: "2.5rem" }}
                >
                  <div class="col-auto profile-image">
                    <a>
                      <div className="BranchLogo">
                        <img class="" alt="User Image" src={profile2} />
                      </div>
                    </a>
                  </div>
                  <div class="col ml-md-n2 profile-user-info">
                  {state.BranchRetrieve.BranchesRetrieve != undefined && state.BranchRetrieve.BranchesRetrieve?.client_name !=
                    undefined ? (
                      <h4
                        class="user-name mb-0"
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "flex-start",
                          gap: "10px",
                          fontWeight: "700",
                           fontSize:"14px",
                        }}
                      >
                        {/* {state.BranchRetrieve.BranchesRetrieve.client_name.toUpperCase()} */}
                        {
                        state.BranchRetrieve.BranchesRetrieve != undefined &&
                        state.BranchRetrieve.BranchesRetrieve !=null ?
                        capital_letter(
                          state.BranchRetrieve.BranchesRetrieve?.client_name
                        )
                      :"--"}
                      

                        {/* <span
                          style={{
                            background: "rgb(255 217 217)",
                            color: "#F57F38",
                            padding: "7px",
                            borderRadius: "13px",
                            cursor: "pointer",
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            setidforuploaddata({
                              ...getidforupload,
                              user_id: "",
                              client_id:
                                state.ClientBranchIDs.clientBranchEditView,
                            });
                            setExcelSheetFORKYCPopup(true);
                          }}
                          className="OuterExcelSheet"
                        >
                          {" "}
                          <i class="fa-solid fa-sheet-plastic"></i>
                          <span
                            style={{
                              color: "#F57F38",
                              marginLeft: "5px",
                              fontSize: "19px",
                              padding: "6px",
                            }}
                            className="excelsheetdisplay"
                          >
                            Excel sheet
                          </span>
                        </span>

 */}
                      </h4>
                    ) : null}
                    {state.BranchRetrieve.BranchesRetrieve != undefined &&
                    state.BranchRetrieve.BranchesRetrieve.zone_id !=
                      undefined &&
                    state.BranchRetrieve.BranchesRetrieve.zone_id != null ? (
                      <p
                        className="superViorName"
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          gap: "20px",
                          color: "#EF5239",
                          fontSize: "14px",
                          // marginTop: "12px",
                        }}
                      >
                        {
                          state.BranchRetrieve.BranchesRetrieve.zone_id
                            .zone_name
                        }

                        {/* <button
                          style={{
                            background: "rgb(255 217 217)",
                            color: "#F57F38",
                            padding: "0px",
                            borderRadius: "13px",
                            fontSize: "18px",
                            cursor: "pointer",
                            //  width:"300px"
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",

                            // padding: "5px",
                            padding: "5px 5px",

                            marginTop: "8px",
                          }}
                          onClick={(e) => {
                            setSuperviorsState(true);
                          }}
                        >

                          <AddModeratorIcon />
                          <span>Supervisor</span>
                        </button> */}
                      </p>
                    ) : null}
                  </div>

                  {/*                   
                  <div
                    class="col-auto profile-btn col-6"
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >

                    <div
                      className="DatePicker daterangeinclientdetails"
                      style={{ width: "80%" }}
                    >
                      <select
                        style={{
                          width: "100%",
                          padding: "10px",
                          marginTop: "10px",
                        }}
                        class="form-select form-select-lg mb-3"
                        aria-label=".form-select-lg example"
                        name="marital_status"
                        readOnly={
                          state.NumberCounts.Editable == 1 ? true : false
                        }
                        onChange={(e) => {
                          HandleChanges(e);
                        }}
                      >
                        {Options.map((item) => (
                          <option
                            value={item.value}
                          >
                            {item.label}
                          </option>
                        ))}
                      </select>

                    

                      <DateRangePicker
                        className="Dateranger"
                        style={{ width: "100%", padding: 10 }}
                        placeholder="Form-To"
                        onChange={handleDateChange}
                        showHeader={false}
                        size="lg"
                        value={selectedDates}
                      />
                    </div>

                    <button
                      style={{
                        borderRadius: "7px",
                        height: "47px",
                        marginTop: "8px",
                        width: "24%",
                      }}
                      class="  editview "
                      onClick={(e) => {
                        e.stopPropagation();

                        if (
                          startDatemon == data.from_date &&
                          endDatemon == data.to_date
                        ) {
                          attendanceexport(e, true, "client");
                        } else {
                          attendanceexport(e, false, "client");
                        }
                      }}
                    >
                      {" "}
                      Attendance Export
                    </button>
                  </div> */}

                  <div class="col-auto profile-btn">
                    {/* <button
                      class=" editview ButtonCSS"
                      onClick={(e) => {
                        dispatch(Branch_EDIT_CLIENT_DETAILS(2)); ///--For----close the--client-----details--
                        e.stopPropagation();
                        setEditPopupBranch(true);
                      }}
                    >
                      Edit
                    </button> */}

                    {/* <button
                      class=" editview ButtonCSS"
                       style={{ display:"flex", }}
                      onClick={(e) => {
                        e.stopPropagation();
                        setidforuploaddata({
                          ...getidforupload,
                          user_id: "",
                          client_id: state.ClientBranchIDs.clientBranchEditView,
                        });
                        setExcelSheetFORKYCPopup(true);
                      }}
                    >
                      <i class="fa-solid fa-sheet-plastic"  style={{ marginLeft:"-25px"}}></i>
                    Excel sheet
                    </button> */}

                    <button
                      class="btn "
                      style={{ background: "#ef4d39", color: "white",display:"flex",gap:"2px" }}
                      onClick={(e) => {
                        e.stopPropagation();
                        setidforuploaddata({
                          ...getidforupload,
                          user_id: "",
                          client_id: state.ClientBranchIDs.clientBranchEditView,
                        });
                        setExcelSheetFORKYCPopup(true);
                      }}
                    >

                      <span className="ExcelSheetImages">
                        <img src={ExcelSheetImage}/>
                      </span>
                      Excel Sheet
                    </button>
                  </div>
                </div>

                <div className="profile-menu TabsStartHead">
                  <div className="innerTabs">
                    <ul class="nav nav-tabs" id="ex1" role="tablist">
                      <li class="nav-item TABHEADER" role="presentation">
                        <button
                          // class=" active"
                          className={`  nav-link   ${
                            state.clientDetailsCall.ActiveClinetTabs == 1
                              ? "active "
                              : ""
                          }`}
                          id="ex3-tab-1"
                          data-bs-toggle="tab"
                          href="#ex3-tabs-1"
                          role="tab"
                          aria-controls="ex3-tabs-1"
                          aria-selected="true"
                          onClick={(e) => {
                            Counting(1);
                            dispatch(setCreateActive(1));

                            dispatch(SettheActiveTabsActionClientDetails(1));
                          }}
                        >
                          Shift
                        </button>
                      </li>

                      <li class="nav-item TABHEADER" role="presentation">
                        <button
                          //  class="nav-link"
                          className={`  nav-link   ${
                            state.clientDetailsCall.ActiveClinetTabs == 2
                              ? "active "
                              : ""
                          }`}
                          id="ex3-tab-2"
                          data-bs-toggle="tab"
                          href="#ex3-tabs-2"
                          role="tab"
                          aria-controls="ex3-tabs-2"
                          aria-selected="false"
                          onClick={(e) => {
                            Counting(2);
                            dispatch(setCreateActive(2));

                            dispatch(SettheActiveTabsActionClientDetails(2));
                          }}
                        >
                          Employee
                        </button>
                      </li>
                      <li class="nav-item TABHEADER" role="presentation">
                        <button
                          /// class="nav-link"
                          className={`  nav-link   ${
                            state.clientDetailsCall.ActiveClinetTabs == 3
                              ? "active "
                              : ""
                          }`}
                          id="ex3-tab-2"
                          data-bs-toggle="tab"
                          href="#leave"
                          role="tab"
                          aria-controls="ex3-tabs-2"
                          aria-selected="false"
                          onClick={(e) => {
                            Counting(2);
                            dispatch(setCreateActive(2));

                            dispatch(SettheActiveTabsActionClientDetails(3));
                          }}
                          //style={{ display: "none" }}
                        >
                          Leave status
                        </button>
                      </li>
                      <li class="nav-item TABHEADER" role="presentation">
                        <button
                          // class="nav-link"
                          className={`  nav-link   ${
                            state.clientDetailsCall.ActiveClinetTabs == 4
                              ? "active "
                              : ""
                          }`}
                          id="ex3-tab-2"
                          data-bs-toggle="tab"
                          href="#shiftExcel"
                          role="tab"
                          aria-controls="ex3-tabs-2"
                          aria-selected="false"
                          onClick={(e) => {
                            Counting(4);
                            dispatch(setCreateActive(4));

                            dispatch(SettheActiveTabsActionClientDetails(4));
                          }}
                          //style={{ display: "none" }}
                        >
                          Shift Upload
                        </button>
                      </li>
                      <li class="nav-item TABHEADER" role="presentation">
                        <button
                          // class="nav-link"
                          className={`  nav-link   ${
                            state.clientDetailsCall.ActiveClinetTabs == 5
                              ? "active "
                              : ""
                          }`}
                          id="ex3-tab-2"
                          data-bs-toggle="tab"
                          href="#Superviors"
                          role="tab"
                          aria-controls="ex3-tabs-2"
                          aria-selected="false"
                          onClick={(e) => {
                            Counting(5);
                            dispatch(setCreateActive(5));
                            dispatch(SettheActiveTabsActionClientDetails(5));
                          }}
                          //style={{ display: "none" }}
                        >
                          Supervisor
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="card BeforeTabs ">
                <div className="card-body innerBody">
                  <div className="TabsStart">
                    <div className="row">
                      <div className="col-12">
                        <div className="card">
                          <div className="card-body DetailsPart">
                            {/* <ul class="nav justify-content-center">
                      <li class="nav-item">
                        <a class="nav-link active" aria-current="page" href="#">
                         Shift
                        </a>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link" href="#">
                        Emp Inquiry
                        </a>
                      </li>
                    </ul> */}

                            <div class="tab-content" id="ex2-content">
                              <div
                                // class=`tab-pane fade show active ``
                                className={`  tab-pane fade show   ${
                                  state.clientDetailsCall.ActiveClinetTabs == 1
                                    ? "active "
                                    : ""
                                }`}
                                id="ex3-tabs-1"
                                role="tabpanel"
                                aria-labelledby="ex3-tab-1"
                              >
                                {/* <div className="InnerUsers">
                              <h3>Shift</h3>
                            </div> */}
                                {/* ////-------------Shift---Branch--Search---- */}
                                {/* <div
                          className="row ShiftSelects"
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            marginRight: "20px",
                          }}
                        >
                          <div className="col-4 mt-3">
                            <label
                              for="validationCustom01"
                              class="form-label"
                              style={{ fontFamily: "Mediumweight" }}
                            >
                              Client Branch Name
                            </label>
                            <Select
                              className="Selects"
                              styles={{ position: "relative", top: "60px" }}
                              // options={options}
                              // onChange={handleChange}
                              onSelect={(e) => setMUltiselectBranch(e)}
                              onRemove={(e) => setMUltiselectBranch(e)}
                              onChange={(e) => {
                                handleBranchNames(e);
                              }}
                              options={branchName}
                              labelledBy="Select"
                            />
                          </div>
                        </div> */}

                                {/* ////------------------SHift------Tables---------------- */}
                                {dataShift != undefined ? (
                                  <div style={{ padding: "0px" }}>
                                    <ReactTable
                                      style={{ zIndex: "142 !important" }}
                                      /// data={state.ShiftList.ShiftLists}
                                      data={state.ShiftSearch.ShiftSearch}
                                      columns={columns}
                                      // totalItems={state.ShiftList.Total_Count}
                                      totalItems={state.ShiftSearch.Total_Count}
                                      currentPage={currentPageShift}
                                      // onPageChange={handlePageChange}
                                      onChange={tochange}
                                      setCurrentPage={setCurrentPage}
                                      pagesize={pagesize}
                                      onPrevious={handlePrevious}
                                      onNextpage={handleNext}
                                      GotoEnteredPage={GotoEnteredPage}
                                      dtpagesize={pageSize}
                                      dtpageindex={currentPageShift}
                                      pageindex={pageindex}
                                      // datacount={state.ShiftList.Total_Count}
                                      datacount={state.ShiftSearch.Total_Count}

                                      Oncreate={(e) => {
                                        // window.location.href = "/shiftCreate";
                                        setShiftCreatePopup(true);
                                        setEditID("");
                                      }}

                                      Filter={true}
                                      NoFilter ={true}
                                      
                                        searchVal={TablePositionPersist?.Shift_empDatas?.search == "" || TablePositionPersist?.Shift_empDatas?.search ==undefined? "":TablePositionPersist.Shift_empDatas.search}
              search_key={true}

                                    />
                                  </div>
                                ) : null}


                              </div>

                              {/* ////-------------EMP---INQURIY----------------- */}
                              <div
                                //  class="tab-pane fade"
                                className={`  tab-pane fade show   ${
                                  state.clientDetailsCall.ActiveClinetTabs == 2
                                    ? "active "
                                    : ""
                                }`}
                                id="ex3-tabs-2"
                                role="tabpanel"
                                aria-labelledby="ex3-tab-2"
                              >
                                <ApproveEmployee />

                                {/* <div className="InnerUsers">
                              <h3>Employee</h3>
                            </div> */}
                                {/* ///----Emp-----Tables---------- */}
                                {/*  */}
                                {/* {EmpDAta != undefined ? ( */}
                                {/* // <div style={{ padding: "0px" }}> */}
                                {/* <ReactTable */}
                                {/* // data={ */}
                                {/* // state.EmployeeListsdata.EmployeeLists */}
                                {/* // } */}
                                {/* // columns={columnsEMp} */}
                                {/* // totalItems={ */}
                                {/* // state.EmployeeListsdata.Total_Count */}
                                {/* // } */}
                                {/* // currentPage={currentPageEmp} */}
                                {/* // onChange={toEmpSearch} */}
                                {/* // setCurrentPage={setcurrentPageemp} */}
                                {/* // pagesize={pagesizeEMP} */}
                                {/* // onPrevious={handlePreviousEmp} */}
                                {/* // onNextpage={handleNextEmp} */}
                                {/* // dtpagesize={pageSizeEMP} */}
                                {/* // dtpageindex={currentPageEmp} */}
                                {/* // pageindex={pageindexEMP} */}
                                {/* // datacount={ */}
                                {/* // state.EmployeeListsdata.Total_Count */}
                                {/* // } */}
                                {/* // onPageChange={handlePageChangeEMP} */}
                                {/* // onFirstPage={handleFirstPageEMP} */}
                                {/* // OnhandleLastpgae={HandleLastPageEMP} */}
                                {/* // Oncreate={(e) => {}} */}
                                {/* // /> */}
                                {/* </div> */}
                                {/* // ) : null} */}
                                {/*  */}
                                {/* ////-----DELETE--------------------------- */}
                                {/* {DeleteEmpPOPUP && */}
                                {/* // state.ClientBranchIDs.clientBranchEditView != */}
                                {/* // undefined ? ( */}
                                {/* // <Delete */}
                                {/* // show={DeleteEmpPOPUP} */}
                                {/* // setShow={setDeletePOPUPEMp} */}
                                {/* // onSubmit={HandleEmpDelete} */}
                                {/* // client_id={ */}
                                {/* // state.ClientBranchIDs.clientBranchEditView */}
                                {/* // } */}
                                {/* // /> */}
                                {/* // ) : null} */}
                                {/* //////--------------Branch---_Edit------------------ */}
                                {/* -------------------EDITPOPUP----------------- */}
                                {/* {EditPopupEmp && currentPageEmp != undefined && EditId != undefined ? (
                              <EmployeeCreate
                                EditId={state.ClientBranchIDs.EmployeeIDs}
                                currentPage={currentPageEmp}
                                client_id={EditId}
                                setShow={setsetEditEmpPOPUP}
                              />
                            ) : null} */}
                                {/* {EmpCreatepopup  && currentPageEmp != undefined && EditId != undefined ?
                              <EmployeeCreate 
                              currentPage={currentPageEmp}  
                              client_id={EditId}
                              setShow={setCreateEmpPopup} />
                              :
                              null
                          } */}
                              </div>

                              {/* -------------------Leave------------Status---------------- */}
                              <div
                                //   class="tab-pane fade "
                                className={`  tab-pane fade show   ${
                                  state.clientDetailsCall.ActiveClinetTabs == 3
                                    ? "active "
                                    : ""
                                }`}
                                id="leave"
                                role="tabpanel"
                                aria-labelledby="ex3-tab-1"
                                //style={{ display: "none" }}
                              >
                                <ReactTable
                                  data={state.LeaveStatusListed.LeaveStatusLis}
                                  columns={LeaveColumn}
                                  totalItems={
                                    state.LeaveStatusListed.Total_Count
                                  }
                                  currentPage={currentPageLeave}
                                  onChange={tochangeLeave}
                                  setCurrentPage={setCurrentPageLeave}
                                  pagesize={pagesizeLevae}
                                  onPrevious={handlePreviousLeave}
                                  onNextpage={handleNextLeave}
                                  GotoEnteredPage={GotoPageEnteredLeave}
                                  dtpagesize={dtpagesizeLeave}
                                  dtpageindex={dtpageindexLevae}
                                  pageindex={pageindexLeave}
                                  datacount={
                                    state.LeaveStatusListed.Total_Count
                                  }
                                  


                                  Filter={true}
                                  NoFilter ={true}

                                            searchVal={TablePositionPersist?.Leave_empDatas?.search == "" || TablePositionPersist?.Leave_empDatas?.search ==undefined? "":TablePositionPersist.Leave_empDatas.search}
              search_key={true}

                                />
                              </div>
                              {/* -------------------Shift---Exce;------------Status---------------- */}
                              <div
                                //  class="tab-pane fade  "

                                className={`  tab-pane fade show  ExcelSheetGetList ${
                                  state.clientDetailsCall.ActiveClinetTabs == 4
                                    ? "active "
                                    : ""
                                }`}
                                id="shiftExcel"
                                // /style={{ display: "none" }}
                                role="tabpanel"
                                aria-labelledby="ex3-tab-2"
                              >
                                <div style={{ padding: "0px" }}>
                                  <ReactTable
                                    data={state.ShfitData.Shiftdatas}
                                    columns={columnShift}
                                    totalItems={state.ShfitData.Total_Count}
                                    currentPage={currentPageEXcel}
                                    onChange={tochangeshiftExcel}
                                    setCurrentPage={setCurrentPageExcel}
                                    pagesize={pagesizeexcel}
                                    onPrevious={handlePreviousExcelSheet}
                                    onNextpage={handleNextexcelsheet}
                                    GotoEnteredPage={GotoEnteredPageExcelPage}
                                    dtpagesize={pageSizeexcel}
                                    dtpageindex={currentPageEXcel}
                                    pageindex={pageindexexcel}
                                    datacount={state.ShfitData.Total_Count}
                                    MakeCreate={true}
                                    ViewParts={(e) => {
                                      handleCalenders(e);
                                    }}
                                    Filter={true}
                                    NoFilter ={true}
                                    searchVal={TablePositionPersist?.ShiftUpload_empDatas?.search == "" || TablePositionPersist?.ShiftUpload_empDatas?.search ==undefined? "":TablePositionPersist.ShiftUpload_empDatas.search}
              search_key={true}

                                  />
                                </div>
                              </div>

                              {/* -------------------------------------Supervor------------- */}
                              <div class="tab-content" id="ex2-content">
                                <div
                                  // class=`tab-pane fade show active ``
                                  className={`  tab-pane fade show   ${
                                    state.clientDetailsCall.ActiveClinetTabs ==
                                    5
                                      ? "active "
                                      : ""
                                  }`}
                                  id="ex3-tabs-1"
                                  role="tabpanel"
                                  aria-labelledby="ex3-tab-1"
                                >
                                  <div className="" style={{ padding: "0px" }}>
                                    {/* <div className="row SupervisorCreateInsideTable">
                                      <div className="col-6">
                                        <button
                                          style={{
                                            background: "rgb(255 217 217)",
                                            color: "#F57F38",
                                            // padding: "0px",
                                            // borderRadius: "13px",
                                            // fontSize: "18px",
                                            // cursor: "pointer",
                                            // //  width:"300px"
                                            // display: "flex",
                                            // flexDirection: "row",
                                            // alignItems: "center",

                                            // // padding: "5px",
                                            // padding: "5px 5px",

                                            // marginTop: "8px",
                                          }}
                                          className="ButtonCSS"
                                          onClick={(e) => {
                                            setSuperviorsState(true);
                                          }}
                                        >
                                          <span>
                                            {" "}
                                            <AddModeratorIcon /> Create
                                            Supervisor
                                          </span>
                                        </button>
                                      </div>
                                    </div> */}

                                    <ReactTable
                                      data={
                                        state.SuperviorsSlice.SuperviorsData
                                      }
                                      columns={columnSuperviorss}
                                      totalItems={
                                        state.SuperviorsSlice.Total_Count
                                      }
                                      currentPage={currentPageSuperviorsSlice}
                                      // onPageChange={handlePageChange}
                                      onChange={tochangeSuperviorsSlice}
                                      setCurrentPage={
                                        setCurrentPageSuperviorsSlice
                                      }
                                      pagesize={pageSuperviorsSlicesize}
                                      onPrevious={handleSuperviorsSlicePrevious}
                                      onNextpage={handleSuperviorsSliceNext}
                                      dtpagesize={dtpagesizeSuperviorsSlice}
                                      GotoEnteredPage={GotoEnteredPageSupervisor}
                                      dtpageindex={currentPageSuperviorsSlice}
                                      pageindex={pageSuperviorsSliceindex}
                                      datacount={
                                        state.SuperviorsSlice.Total_Count
                                      }
                                      setsno={setsno}
                                      sno={sno}
                                      id={"spe"}
                                      // Filter={true}
                                      // MakeCreate={false}
                                      // Superviorsfilter={true}
                                      // supervisoreOptions={supervisoreOptions}
                                      // TypeOfsuperviors={TypeOfsuperviors}
                                      // superviorChanges={superviorChanges}

                                      // Filter={false}
                                      MakeCreate={false}

                                      Filter={true}
                                      NoFilter ={true}
                                      searchVal={TablePositionPersist?.Supervisor_empDatas?.search == "" || TablePositionPersist?.Supervisor_empDatas?.search ==undefined? "":TablePositionPersist.Supervisor_empDatas.search}
                                      search_key={true}

                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {EditBranchPOPUP && BranchEditid != "" ? (
        <ClientBranchCreate
          show={state.ClientBranchIDs.ClientEditFunctions}
          setShow={setEditPopupBranch}
          currentPage={1}
          EditId={BranchEditid}
        />
      ) : null}
      {state.ClientBranchIDs.clientBranchEditView != undefined &&
      ExcelSheetpop ? (
        <ExcelSheetUpload
          show={ExcelSheetpop}
          setShow={setExcelSheetPo}
          branchId={state.ClientBranchIDs.clientBranchEditView}
          page={currentPageEXcel}
        />
      ) : null}

      {/* ---------------------___Site-------------------_Transfer------------------- */}

      <>
        {createpoup ? (
          <SiteCreateEdit
            show={createpoup}
            setShow={setcreatepoup}
            currentPage={newpages}
            EditId={EmployeeIDs}
            selectVal={""}
            datas={""}
          />
        ) : null}
      </>

      {/* ----Black----list---------------------------------- */}
      {createblack ? (
        <BlackListCeatePoup
          show={createblack}
          setShow={setcreatepoupblack}
          ActiveFor={1}
          currentPage={newpages}
          EditId={EmployeeIDsblacklist}
          selectVal={""}
          datas={""}
        />
      ) : null}

      <>
        {/* <Tooltip id="Name-ToolTips" zIndex={999} /> */}
      </>

      <>
        {ExcelSheeTFORKYCPopup ? (
          <ExcelFormatDwonload
            show={ExcelSheeTFORKYCPopup}
            setShow={setExcelSheetFORKYCPopup}
            EditID={getidforupload}
          />
        ) : null}
      </>

      <>
        {InActiveCreatePop &&
        InActiveCreateId != "" &&
        InActiveCreateId != undefined ? (
          <ActiveEmployeeCreate
            show={InActiveCreatePop}
            setShow={setInActiveCreatePoup}
            UserID={InActiveCreateId}
          />
        ) : null}
      </>
      <>
        {SuperviorsState ? (
          <Superviors
            show={SuperviorsState}
            setShow={setSuperviorsState}
            client_id={state.ClientBranchIDs.clientBranchEditView}
            old_employee={oldemplo.old_employee}
            page={dtpageindexSuperviorsSlice}
            search={searchSuperviorsSlice}
          />
        ) : null}
      </>

      <>
      {/* ------Shift--create--edit----- */}
      {EditPopup &&
                                state.ClientBranchIDs.clientBranchEditView !=
                                  "" &&
                                currentPageShift != undefined ? (
                                  <ShiftCreateForm
                                    EditId={EditIDSHIFT}
                                    client_id={
                                      state.ClientBranchIDs.clientBranchEditView
                                    }
                                    currentPageShift={currentPageShift}
                                    setShow={setEditpopup}
                                  />
                                ) : null}
                                {ShiftCreatePOPup &&
                                state.ClientBranchIDs.clientBranchEditView !=
                                  "" &&
                                currentPageShift != undefined ? (
                                  <ShiftCreateForm
                                    client_id={
                                      state.ClientBranchIDs.clientBranchEditView
                                    }
                                    setShow={setShiftCreatePopup}
                                    currentPageShift={currentPageShift}
                                  />
                                ) : null}

                                {DeletePOPUP ? (
                                  <Delete
                                    show={DeletePOPUP}
                                    setShow={setDeletePOPUP}
                                    onSubmit={HandelDelete}
                                    Content={"Do you want to delete the Shift"}
                                  />
                                ) : null}
      
      </>
    </>
  );
};

export default ClientDetails;
